import React from 'react';
import { RiskSimulatorHeader } from '@/layouts/MainLayout/components/HeaderWithNavigation/components/Headers/RiskSimulatorHeader/RiskSimulatorHeader';
import { DocumentationHeader } from '@/layouts/MainLayout/components/HeaderWithNavigation/components/Headers/DocumentationHeader/DocumentationHeader';
import { SettingsHeader } from '@/layouts/MainLayout/components/HeaderWithNavigation/components/Headers/SettingsHeader/SettingsHeader';
import { DashboardHeader } from '@/layouts/MainLayout/components/HeaderWithNavigation/components/Headers/DashboardHeader/DashboardHeader';
import { EntityHeader } from '@/layouts/MainLayout/components/HeaderWithNavigation/components/Headers/EntityHeader/EntityHeader';
import { ReservesMonitoringHeader } from '@/layouts/MainLayout/components/HeaderWithNavigation/components/Headers/ReservesMonitoringHeader/ReservesMonitoringHeader';
import { StablecoinsHeader } from '@/layouts/MainLayout/components/HeaderWithNavigation/components/Headers/StablecoinsHeader/StablecoinsHeader';
import { DashboardSettingsHeader } from '@/layouts/MainLayout/components/HeaderWithNavigation/components/Headers/DashboardSettingsHeader/DashboardSettingsHeader';
import { AlertingHeader } from '@/layouts/MainLayout/components/HeaderWithNavigation/components/Headers/AlertingHeader/AlertingHeader';
import { AlertingSettingsHeader } from '@/layouts/MainLayout/components/HeaderWithNavigation/components/Headers/AlertingSettingsHeader/AlertingSettingsHeader';
import { THeader } from '@/layouts/MainLayout/utils/types';

export const generateHeader = (header?: THeader) => {
  switch (header) {
    case 'riskSimulator':
      return <RiskSimulatorHeader />;
    case 'dashboard':
      return <DashboardHeader />;
    case 'dashboardSettings':
      return <DashboardSettingsHeader />;
    case 'entity':
      return <EntityHeader />;
    case 'stablecoins':
      return <StablecoinsHeader />;
    case 'stablecoinDetail':
      return <ReservesMonitoringHeader />;
    case 'documentation':
      return <DocumentationHeader />;
    case 'settings':
      return <SettingsHeader />;
    case 'alerting':
      return <AlertingHeader />;
    case 'alertingSettings':
      return <AlertingSettingsHeader />;
    default:
      return null;
  }
};
